import { client } from "./client";

const ROUTES = {
  getJob: (jobId) => `/jobs/jobs/${jobId}/`,
  getJobFile: (jobId) => `/jobs/job_file/${jobId}/`,
  getJobs: ({docId, limit, offset}) => `/jobs/jobs/?documents__id=${docId}&limit=${limit}&offset=${offset}`
};

export const jobs = {
  getJob: ({ id }) => {
    return client.get(ROUTES.getJob(id));
  },
  getJobFile: ({ id }) => {
    return client.get(ROUTES.getJobFile(id));
  },
  getJobs: ({documentId, limit, offset}) => {
    return client.get(ROUTES.getJobs({docId: documentId, limit: limit, offset: offset}));
  }
};
